module.exports = __webpack_public_path__ + "static/unicef_white-2211ebc971147df16dbca4f29ea60615.svg";